module.exports = __webpack_public_path__ + "media/images/cureus_icon_2014-f9b396e3b2a1f46618b7ebc2fc6b9af1.png";